import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Autocomplete, Box, IconButton, TextField } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import currencySymbolMap from "currency-symbol-map";
import {
  AllCountriesModel,
  AppraisalAssetsModel,
  AppraisalDetailsModelForDLorDA,
} from "../../../all_Interfaces";
import { updateAppraisalDetailsForUSAppraisal } from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { useDispatch } from "react-redux";
import { updateAppraisalDetailsForDLorDA } from "../../../redux/slices/AppraisalDetailsForDLorDASlice";
import dayjs, { Dayjs } from "dayjs";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import Divider from '@mui/material/Divider';

export const AppraisalValueTableForDLorDA = (props: any) => {
  const dispatch = useDispatch();
  const [currencyObj, setCurrencyObj] = useState<AllCountriesModel>({
    id: 4,
    countryName: "United States of America",
    countryCode: "USD",
    localId: "en_US",
  });
  const modifiedAssets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [modifiedAsset, setModifiedAsset] = useState<AppraisalAssetsModel[]>(
    []
  );
  const today = new Date();
  const [appraisalsDetails, setAppraisalDetails] =
    useState<AppraisalDetailsModelForDLorDA>({
      currencySelected: "",
      currentDebtValue: null,
      currentPrincipalValue: null,
      loanToValueRatio: null,
      treasuryRate: null,
      riskPremium: null,
      surveyYield: null,
      currentEffectiveDate: "",
      derivative: null,
      lastDebtValue: null,
      lastDebtPercentageChange: null,
      lastDebtEffectiveDate: "",
    });
  

  const appraisalDetailsForDLorDA: AppraisalDetailsModelForDLorDA =
    useAppSelector((state) => state.AppraisalDetailsForDLorDA.data);
  useEffect(() => {
    if (currencyObj?.countryCode != "ZH") {
      setCurrencySymbol(currencySymbolMap(currencyObj.countryCode) as string);
    } else {
      setCurrencySymbol("ZH");
    }
  }, [currencyObj]);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );

  useEffect(() => {
    setModifiedAsset(modifiedAssets);
    console.log(modifiedAssets);
  }, [modifiedAssets]);

  useEffect(() => {
    setIsSubmit(submitEvent);
  }, [submitEvent]);
  useEffect(() => {

    var change = appraisalDetailsForDLorDA.currentDebtValue !== null &&
      appraisalDetailsForDLorDA.lastDebtValue
      ? parseFloat((
        ((Number(appraisalDetailsForDLorDA.currentDebtValue.toString().replace(/,/g,"")) -
        Number(appraisalDetailsForDLorDA.lastDebtValue.toString().replace(/,/g,""))) /
        Number(appraisalDetailsForDLorDA.lastDebtValue.toString().replace(/,/g,""))) *
        100
      ).toFixed(2)) : 0;

      

    setAppraisalDetails({
      ...appraisalsDetails,
      currentDebtValue:
        appraisalDetailsForDLorDA.currentDebtValue !== null
          ? appraisalDetailsForDLorDA.currentDebtValue
          : null,
      currentPrincipalValue:
        appraisalDetailsForDLorDA.currentPrincipalValue !== null
          ? appraisalDetailsForDLorDA.currentPrincipalValue
          : null,
      loanToValueRatio:
        appraisalDetailsForDLorDA.loanToValueRatio !== null && appraisalDetailsForDLorDA.loanToValueRatio !== undefined
          ? ( appraisalDetailsForDLorDA.loanToValueRatio === 0 ? 0 : appraisalDetailsForDLorDA.loanToValueRatio.toLocaleString("en", { minimumFractionDigits: 2 }))
          : null,
      treasuryRate:
        appraisalDetailsForDLorDA.treasuryRate !== null && appraisalDetailsForDLorDA.treasuryRate !== undefined
          ? ( appraisalDetailsForDLorDA.treasuryRate === 0 ? 0 : appraisalDetailsForDLorDA.treasuryRate.toLocaleString("en", { minimumFractionDigits: 2 }))
          : null,
      riskPremium:
        appraisalDetailsForDLorDA.riskPremium !== null && appraisalDetailsForDLorDA.riskPremium !== undefined
          ? ( appraisalDetailsForDLorDA.riskPremium === 0 ? 0 : appraisalDetailsForDLorDA.riskPremium.toLocaleString("en", { minimumFractionDigits: 2 }))
          : null,
      surveyYield:
        appraisalDetailsForDLorDA.surveyYield !== null && appraisalDetailsForDLorDA.surveyYield !== undefined
          ? ( appraisalDetailsForDLorDA.surveyYield === 0 ? 0 : appraisalDetailsForDLorDA.surveyYield.toLocaleString("en", { minimumFractionDigits: 2 }))
          : null,
      currentEffectiveDate:
        appraisalDetailsForDLorDA.currentEffectiveDate !== null ||
        appraisalDetailsForDLorDA.currentEffectiveDate !== ""
          ? appraisalDetailsForDLorDA.currentEffectiveDate
          : dayjs(today).format("MM-DD-YYYY"),
      derivative:
        appraisalDetailsForDLorDA.derivative !== null
          ? appraisalDetailsForDLorDA.derivative
          : null,
      lastDebtValue:
        appraisalDetailsForDLorDA.lastDebtValue !== null
          ? appraisalDetailsForDLorDA.lastDebtValue
          : null,
      currencySelected:
        appraisalDetailsForDLorDA.currencySelected !== null
          ? appraisalDetailsForDLorDA.currencySelected
          : "",
      lastDebtPercentageChange:
        (appraisalDetailsForDLorDA.lastDebtPercentageChange !== null ||
          ((appraisalDetailsForDLorDA.currentDebtValue !== null &&
          appraisalDetailsForDLorDA.lastDebtValue !== null
            ? Number(
                appraisalDetailsForDLorDA.currentDebtValue
                  .toString()
                  .replace(/,/g, "")
              ) > 0 &&
              Number(
                appraisalDetailsForDLorDA.lastDebtValue
                  .toString()
                  .replace(/,/g, "")
              ) > 0
            : false) &&
            appraisalDetailsForDLorDA.lastDebtPercentageChange === 0)) &&
        appraisalDetailsForDLorDA.lastDebtPercentageChange != Infinity
          ? change
          : null,
      lastDebtEffectiveDate:
        appraisalDetailsForDLorDA.lastDebtEffectiveDate !== null
          ? appraisalDetailsForDLorDA.lastDebtEffectiveDate
          : "",
    });

    var countriesData:AllCountriesModel[] = [...props.countriesData];
    var cur:string = appraisalDetailsForDLorDA.currencySelected != ""? appraisalDetailsForDLorDA.currencySelected:"USD";
    var a = countriesData.find((a) =>  a.countryCode == cur);
    if(a != undefined)
    setCurrencyObj(a);
  }, [appraisalDetailsForDLorDA]);

  const handleCurrencyChange = (value: AllCountriesModel) => {
    setCurrencyObj(value);
    dispatch(
      updateAppraisalDetailsForDLorDA({
        ...appraisalsDetails,
        currencySelected: value.countryCode,
      })
    );
  };



  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

    return '';
  }
  const handleCurrentDebtValueChange = (currentDebtValue: string) => {
    const plainNumber = currentDebtValue.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForDLorDA({
        ...appraisalsDetails,
        currentDebtValue: formatedValue,
      })
    );
    if (modifiedAsset.length === 1) {
      var assets = JSON.parse(JSON.stringify(modifiedAssets));
      assets[0] = { ...assets[0], currentAppraisalValue: formatedValue };
      dispatch(updateAppraisalAssets(assets));
    }
  }
  };
    const handleCurrentPrincipalValueChange = (currentPrincipalValue: string) => {
      const plainNumber = currentPrincipalValue.replace(/,/g,'');
      if(!isNaN(Number(plainNumber))){
        var formatedValue = formatNumberWithCommas(plainNumber);
      dispatch(
        updateAppraisalDetailsForDLorDA({
          ...appraisalsDetails,
          currentPrincipalValue: formatedValue,
        })
      );
    }
  }
      const handleLoanToValueRatioChange = (loanToValueRatio: string) => {
        const plainNumber = loanToValueRatio.replace(/,/g,'');
        if(!isNaN(Number(plainNumber))){
          var formatedValue = formatNumberWithCommas(plainNumber);
        dispatch(
          updateAppraisalDetailsForDLorDA({
            ...appraisalsDetails,
            loanToValueRatio: formatedValue,
          })
        );
      }
    }
        const handletreasuryRateChange = (treasuryRate: string) => {
          const plainNumber = treasuryRate.replace(/,/g,'');
          if(!isNaN(Number(plainNumber))){
            var formatedValue = formatNumberWithCommas(plainNumber);
          dispatch(
            updateAppraisalDetailsForDLorDA({
              ...appraisalsDetails,
              treasuryRate: formatedValue,
            })
          );
        }
      }
          const handleRiskPremiumChange = (riskPremium: string) => {
            const plainNumber = riskPremium.replace(/,/g,'');
            if(!isNaN(Number(plainNumber))){
              var formatedValue = formatNumberWithCommas(plainNumber);
            dispatch(
              updateAppraisalDetailsForDLorDA({
                ...appraisalsDetails,
                riskPremium: formatedValue,
              })
            );
            }
        }
            const handlesurveyYieldChange = (surveyYield: string) => {
              const plainNumber = surveyYield.replace(/,/g,'');
              if(!isNaN(Number(plainNumber))){
                var formatedValue = formatNumberWithCommas(plainNumber);
              dispatch(
                updateAppraisalDetailsForDLorDA({
                  ...appraisalsDetails,
                  surveyYield: formatedValue,
                })
              );
            }
          }


  
  const handleLastDebtValueChange = (lastDebtValue: string) => {
    const plainNumber = lastDebtValue.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForDLorDA({
        ...appraisalsDetails,
        lastDebtValue: formatedValue,
      })
    );

    if (modifiedAsset.length === 1) {
      var assets = JSON.parse(JSON.stringify(modifiedAssets));
      assets[0] = { ...assets[0], lastDebtValue: formatedValue };
      dispatch(updateAppraisalAssets(assets));
    }
  }
  };

  const handleEffectiveDateChange = (d: dayjs.Dayjs | null) => {
    console.log(d);
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForDLorDA({
          ...appraisalsDetails,
          currentEffectiveDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleLastDebtEffectiveDateChange= (d: dayjs.Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForDLorDA({
          ...appraisalsDetails,
          lastDebtEffectiveDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleDerivativeChange = (derivative: string) => {
    const plainNumber = derivative.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForDLorDA({
        ...appraisalsDetails,
        derivative: formatedValue,
      })
    );
  }
  };
  const handlePercentageChange = () => {
    if (appraisalsDetails.currentDebtValue !== 0 && appraisalsDetails.currentDebtValue !== null && appraisalsDetails.currentDebtValue !== "0") {
      var lastValuePercentage;
      if (appraisalsDetails.lastDebtValue != 0 && appraisalsDetails.lastDebtValue != null && appraisalsDetails.lastDebtValue != "0") {
        let percentage =
          ((Number(appraisalsDetails.currentDebtValue.toString().replace(/,/g,"")) -
          Number(appraisalsDetails.lastDebtValue.toString().replace(/,/g,""))) /
          Number(appraisalsDetails.lastDebtValue.toString().replace(/,/g,""))) *
          100;
        lastValuePercentage = (percentage.toFixed(2));
      }
      dispatch(
        updateAppraisalDetailsForDLorDA({
          ...appraisalsDetails,
          lastDebtPercentageChange: lastValuePercentage,
        })
      );
    }
  };


  // to handle datePicker error
  useEffect(() => {
    if ((appraisalsDetails.currentEffectiveDate == null || appraisalsDetails.currentEffectiveDate == "") && isSubmit) {
      dispatch(
        updateAppraisalDetailsForDLorDA({
          ...appraisalsDetails,
          currentEffectiveDate: dayjs(
            "12-24-0001",
            "MM-DD-YYYY"
          ).format('dd-mm-yyyy hh-mm-ss'),
        })
      );
    }
  }, [isSubmit]);

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 650 }}
        size="small"
        aria-label="a dense table"
        className="appraisal-value-table"
      >
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>% Change</TableCell>
            <TableCell>
              Effective Date of Value <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell>Derivative</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              Current Debt Value <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell>
              <Autocomplete
                clearIcon={null}
                readOnly={
                  props.flagToDisableControlesForAppraisal || props.view
                }
                id="Currency"
                options={props.countriesData.sort((a: any, b: any) =>
                  a.countryCode.localeCompare(b.countryCode)
                )}
                value={currencyObj}
                getOptionLabel={(option: AllCountriesModel) => {
                  return option.countryCode;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.countryCode}
                  </Box>
                )}
                onChange={(e, value) => {
                  handleCurrencyChange(value as AllCountriesModel);
                }}
                sx={{ width: 120 }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="current debt value"
                  type="text"
                  value={formatNumberWithCommas(appraisalsDetails.currentDebtValue)}
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  onChange={(e) =>
                    handleCurrentDebtValueChange(e.target.value)
                  }
                  onBlur={() => handlePercentageChange()}
                  error={
                    (!appraisalsDetails.currentDebtValue && isSubmit) ||
                    (appraisalsDetails.currentDebtValue == null && isSubmit)
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell></TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  sx={{ overflowY: "hidden" }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    name="current effective date"
                    format="MMM-DD-YYYY"
                    readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                    onChange={(newValue: Dayjs | null) =>
                      handleEffectiveDateChange(newValue)
                    }
                    value={
                      appraisalsDetails.currentEffectiveDate === "" ||
                      appraisalsDetails.currentEffectiveDate == null
                        ? null
                        : dayjs(
                            appraisalsDetails.currentEffectiveDate,
                            "MM-DD-YYYY"
                          )
                    }
                    views={["month", "day", "year"]}
                    slotProps={{
                      textField: { size: "small", placeholder: "MMM-DD-YYYY" },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="derivative"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  type="text"
                  onChange={(e) => handleDerivativeChange(e.target.value)}
                  value={formatNumberWithCommas(appraisalsDetails.derivative)}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">
                Last Debt Value{" "}
                <IconButton
                  onClick={() => {
                    props.openLastAppraisalValue(
                      "GetLastPostedAppraisalIdByInv"
                    );
                  }}
                >
                  <OpenInNewIcon fontSize="small" />
                </IconButton>
              </span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly = {!props.postEditForAdmin}
                  type="text"
                  className="Autopopulatefield"
                  value={formatNumberWithCommas(appraisalsDetails.lastDebtValue)}
                  onChange={(e) =>
                    handleLastDebtValueChange(e.target.value)
                  }
                  onBlur={() => handlePercentageChange()}
                  id="last debt value"
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  readOnly
                  className="Autopopulatefield"
                  type="number"
                  id="last debt percentage change"
                  value={appraisalsDetails.lastDebtPercentageChange}
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  sx={{ overflowY: "hidden" }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    readOnly={!props.postEditForAdmin}
                    format="MMM-DD-YYYY"
                    value={
                      appraisalsDetails.lastDebtEffectiveDate === "" ||
                      appraisalsDetails.lastDebtEffectiveDate == null
                        ? null
                        : dayjs(
                            appraisalsDetails.lastDebtEffectiveDate,
                            "MM-DD-YYYY"
                          )
                    }
                    onChange={(newValue: Dayjs | null) =>
                      handleLastDebtEffectiveDateChange(newValue)
                    }
                    views={["month", "day", "year"]}
                    className="Autopopulatefield"
                    name="last effective date"
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "MMM-DD-YYYY",
                        disabled: true,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow>
          </TableRow>
          <TableRow >
          <TableCell colSpan={6} style={{height: "15px"}}> </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Current Principal Balance Value <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell></TableCell>
            <TableCell>
                Loan to Value Ratio <span style={{ color: "red" }}></span>
            </TableCell>
            <TableCell>
              Treasury Rate<span style={{ color: "red" }}></span>
            </TableCell>
            <TableCell>
                Risk Premium <span style={{ color: "red" }}></span>
            </TableCell>
            <TableCell>
              Survey Yield <span style={{ color: "red" }}></span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="current principal value"
                  type="text"
                  value={formatNumberWithCommas(
                    appraisalsDetails.currentPrincipalValue
                  )}
                  onChange={(e) =>
                    handleCurrentPrincipalValueChange(e.target.value)
                  }
                  readOnly={
                    (props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin
                  }
                  error={
                    (!appraisalsDetails.currentPrincipalValue && isSubmit) ||
                    (appraisalsDetails.currentPrincipalValue == null &&
                      isSubmit)
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
              <TableCell></TableCell>
            </TableCell>
            <TableCell></TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="loan to value ratio"
                  type="text"
                  value={formatNumberWithCommas(
                    appraisalsDetails.loanToValueRatio
                  )}
                  onChange={(e) => handleLoanToValueRatioChange(e.target.value)}
                  readOnly={
                    (props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin
                  }
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="treasury rate"
                  type="text"
                  value={formatNumberWithCommas(appraisalsDetails.treasuryRate)}
                  onChange={(e) => handletreasuryRateChange(e.target.value)}
                  readOnly={
                    (props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin
                  }
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>

            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="risk premium"
                  type="text"
                  value={formatNumberWithCommas(appraisalsDetails.riskPremium)}
                  onChange={(e) => handleRiskPremiumChange(e.target.value)}
                  readOnly={
                    (props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin
                  }
                 
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="survey yield"
                  type="text"
                  value={formatNumberWithCommas(appraisalsDetails.surveyYield)}
                  onChange={(e) => handlesurveyYieldChange(e.target.value)}
                  readOnly={
                    (props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin
                  }
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};